export default __webpack_public_path__ + "static/media/pictogramBeaconUnlock48.04f8312b.svg";